export const currency = (num, sign = true) => {
  return new Intl.NumberFormat('es-MX', {
    style: sign ? 'currency' : 'decimal',
    currency: 'MXN',
    minimumFractionDigits: 2,
  }).format(num)
}